import _BaseUserProfile from 'Models/UserProfile/_BaseUserProfile';

export default class DrivingLicensePhotoUrl extends _BaseUserProfile {
  component = 'PhotoField';
  props = {
    title: 'Please take a photo of your driver’s license.',
    errorMessage: 'Photo is Required',
    additionalFormInModal: false,
  };
  hideClearUntilValue = true;
}
